import Cookie from '../modules/cookie';
import tpl from '../templates/newsletter.html';
import template from 'lodash/template';
import Overlay from '../utils/overlay';
import WTF from '@zuul/wtf/native';
import Schema from '../modules/newsletter/schema';

const compiledTPL = template(tpl);
const cookieName = 'hasSeenPopup';

export default class NewsLetter extends Overlay {
    constructor({el}) {
        super({el});

        this.el = el;
        this.open = false;

        this.cookie = new Cookie({
            name: cookieName
        });

        if (this.cookie.get() === null) {
            this.el.classList.add('overlay');
            this.show();
            this.bindOverlay();
        } else {
            this.el.parentNode.removeChild(this.el);
        }
    }

    show() {
        const html = compiledTPL({});
        
        this.el.innerHTML = html;

        const el = this.el.querySelector('[data-module="NewsletterForm"]');

        this.schema = new Schema();

        new WTF({ // eslint-disable-line no-new
            el,
            schema: this.schema.data
        });
        this.open = true;

        this.cookie.set('yes');
    }

    bindOverlay() {
        const overlay = document.querySelector('.overlay');

        document.querySelector('.overlay .close').addEventListener('click', evt => {
            evt.preventDefault();

            overlay.parentNode.removeChild(overlay);
        });
    }
}
